export const POKEMON_REQUEST = 'POKEMON_REQUEST';
export const POKEMON_FAILURE = 'POKEMON_FAILURE';
export const ADD_ALL_POKEMONS = 'ADD_ALL_POKEMONS';
export const UPDATE_SELECTED_POKEMON = 'UPDATE_SELECTED_POKEMON';
export const UPDATE_SPECIES_SELECTED_POKEMON = 'UPDATE_SPECIES_SELECTED_POKEMON';
export const UPDATE_EVOLUTION_SELECTED_POKEMON = 'UPDATE_EVOLUTION_SELECTED_POKEMON';
export const UPDATE_CATEGORY_LIST = 'UPDATE_CATEGORY_LIST';
export const UPDATE_FILTER_POKEMON = 'UPDATE_FILTER_POKEMON';
